import { experiments_view } from "../../../../service/apis";
import auth from '../../../../service/Auth';

const getCurrentExperimentValues = async(rows) => {
    // 1. Get Current Experiment Fields 
    let fields_to_query = [];
    let filtered = [{id: "ExperimentID", value:[]}];
    for (let row of rows) {
        for (const key in row) {
            if (key !== "id") {
                // 1.1 Set Fields To Query
                if (!(fields_to_query.includes(key))){
                    fields_to_query = [...fields_to_query,key];
                }
                // 1.2 Set Experiments to Filter 
                if (key === "ExperimentID") {
                    filtered[0].value.push(row[key]);
                }
            }
        }
    }
    // 2. Query Experiments View
    let data_query = { 
        page : 1, pageSize: 100,
        fields : fields_to_query, filtered : filtered,
        sorted: []
    };
    let getData = true;
    let allItems = [];
    // 2.1 Get All Data
    while (getData){
        await experiments_view(auth.getToken(),config.api_endpoint, JSON.stringify(data_query))
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            allItems.push(...data["items"]);
            if (data_query.page < data["_meta"]["total_pages"]){
                getData = true;
                data_query.page = data_query.page + 1;
            }
            else getData = false;
        })
    }
    return allItems;
}

export const parseTsvFile = async (data) => { 
    let isFirst = true;
    let rowId = 0;
    let cols = [{ field: 'id', headerName: 'ID', width: 70, hide: true }];
    let rowsTmp = [];
    // 1. Parse Data
    for (let row of data){
        //1.1 Avoid Header
        if(isFirst){
            isFirst = false;
            for (let header of row) {
                cols = [...cols, {field:header, headerName: header, width: 200}];
            }
        }
        else{
            if (row.length === cols.length - 1) {
                let index = 1;
                let rowTmp = {id:rowId};
                for (let value of row) {
                    rowTmp[cols[index].field] = value;
                    index = index + 1;
                }
                rowsTmp = [...rowsTmp, rowTmp];
            }                
        }
        rowId = rowId + 1;
    }
    // 2. Get Current Data
    let currentRows = await getCurrentExperimentValues(rowsTmp);
    for (let currentRow of currentRows){
        for (const key in currentRow) {
            // 2.1 Update non ExperimentID Keys
            if ( key !== "ExperimentID") {
                // 2.2 Edit Heeader Current Field
                let currentField = "Current_" + key;
                if (cols.findIndex((item)=> item.field === currentField) == -1){
                    let colIndex = cols.findIndex((item) => item.field == key);
                    cols.splice(colIndex, 0, {field:currentField, headerName: currentField, width: 200});
                }
                // 2.2 Edit Row Current Value
                let rowObject = rowsTmp.find((row) => row.ExperimentID == currentRow.ExperimentID);
                rowObject[currentField] = currentRow[key];
            }
        }
    }
    // 3. Update States
    return { columns: cols, rows: rowsTmp};    
}
